import React, { Component } from 'react';
import { Route as Match, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { loadBuilding } from '../../actions/building';

import BuildingComponent from '../../components/Building';
import withValidTrafic from 'decorators/withValidTrafic';

@withValidTrafic()
class Building extends Component {
  state = { loaded: false };
  UNSAFE_componentWillMount() {
    const { loadBuilding, match: { params } } = this.props;
    loadBuilding(params.id);
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const { loadBuilding, match: { params } } = this.props;
    const { params: nextParams } = nextProps.match;
    if (!nextProps.building.isLoading && !this.state.loaded) {
      this.setState({ loaded: true });
    }
    if (params.id !== nextParams.id) {
      loadBuilding(nextParams.id);
      document.body.scrollTop = 0;
    }
  }

  render() {
    const { dispatch, building, match: { params, path }, match, search } = this.props;
    // console.log(building, this.state);
    // if (building.isLoading || !this.state.loaded) return null;
    const isBuildingLoading = building.isLoading || !this.state.loaded;

    return (
      <Match
        render={(matchProps) => (
          <Switch>
            <Match
              path={`${path}/chess`}
              render={() => (
                <BuildingComponent.Chess
                  {...matchProps}
                  dispatch={dispatch}
                  match={match}
                  params={params}
                  search={search}
                  building={building}
                  isBuildingLoading={isBuildingLoading}
                />
            )}
            />
            <Match
              render={() => (
                <BuildingComponent.Main
                  {...matchProps}
                  dispatch={dispatch}
                  match={match}
                  params={params}
                  building={building}
                  withClient={this.props.privacy.withClient}
                  isBuildingLoading={isBuildingLoading}
                />
            )}
            />
          </Switch>
      )}
      />
    );
  }
}

const buildingSelector = createSelector(
  state => state.building,
  state => state.privacy,
  state => state.search,
  (building, privacy, search) => ({ building, privacy, search })
);

export default connect(buildingSelector, { loadBuilding })(Building);



// WEBPACK FOOTER //
// ./src/containers/Building/Building.js